import { gql } from 'urql'

export const queryFeatureTypeConfigs = gql`
  query ($featureTypesCondition: feature_type_config_bool_exp, $offset: Int!, $limit: Int!) {
    feature_type_config(
      where: $featureTypesCondition
      offset: $offset
      limit: $limit
      order_by: [{ feature_type_name_locale: asc }, { id: asc }]
    ) {
      id
      feature_type_name_locale
      active
      feature_configs {
        processes
      }
      feature_type_deletability {
        is_deletable
      }
    }
    feature_type_config_aggregate(where: $featureTypesCondition) {
      aggregate {
        count
      }
    }
  }
`

export const queryAllFeatureTypeConfigs = gql`
  query {
    feature_type_config {
      id
      names
      active
    }
  }
`

export const queryAllFeatureTypeConfigsForFilter = gql`
  query {
    feature_type_config {
      id
      names
    }
  }
`

export const queryFeatureTypeConfigByIdAsSelectOption = gql`
  query ($featureTypeId: Int!) {
    feature_type_config(where: { id: { _eq: $featureTypeId } }) {
      id
      names
      active
    }
  }
`

export const queryFeatureTypeConfigById = gql`
  query ($featureTypeId: Int!) {
    feature_type_config(where: { id: { _eq: $featureTypeId } }) {
      id
      names
      description
      active
      has_kap_factsheet_validation
      help_and_instruction_key
    }
  }
`

// TODO VVL 2025-07-15: [GFS008GFSP-1912] This query will be redundant and should not be used once we drop the sort_number column.
export const queryHighestFeatureTypeSortNumber = gql`
  query {
    feature_type_config_aggregate {
      aggregate {
        max {
          sort_number
        }
      }
    }
  }
`

export const insertFeatureTypeConfig = gql`
  mutation ($featureTypeInsertInput: [feature_type_config_insert_input!]!) {
    insert_feature_type_config(objects: $featureTypeInsertInput) {
      affected_rows
    }
  }
`

export const updateFeatureTypeConfigById = gql`
  mutation ($featureTypeId: Int!, $featureTypeConfigSetInput: feature_type_config_set_input!) {
    update_feature_type_config(where: { id: { _eq: $featureTypeId } }, _set: $featureTypeConfigSetInput) {
      affected_rows
    }
  }
`

export const updateFeatureTypeConfigAndRelatedFeatureGroupsByTypeId = gql`
  mutation (
    $featureTypeId: Int!
    $featureTypeConfigSetInput: feature_type_config_set_input!
    $featureGroupConfigSetInput: feature_group_config_set_input!
    $featureConfigSetInput: feature_config_set_input!
  ) {
    update_feature_type_config(where: { id: { _eq: $featureTypeId } }, _set: $featureTypeConfigSetInput) {
      affected_rows
    }
    update_feature_group_config(
      where: { feature_type_id: { _eq: $featureTypeId } }
      _set: $featureGroupConfigSetInput
    ) {
      affected_rows
    }
    update_feature_config(where: { feature_type_id: { _eq: $featureTypeId } }, _set: $featureConfigSetInput) {
      affected_rows
    }
  }
`

export const deleteFeatureTypeConfigById = gql`
  mutation ($featureTypeId: Int!) {
    delete_feature_type_config(where: { id: { _eq: $featureTypeId } }) {
      affected_rows
    }
  }
`
